<template>
  <b-modal :id="id" :title="$t('dharma-application-form.message.application-notice.title')" centered>
    <div v-if="section === 1">
      <ol style="list-style-type: disc;">
        <li>{{ $t(`dharma-application-form.message.application-notice.content[0][0]`) }}</li>
        <li>{{ $t(`dharma-application-form.message.application-notice.content[0][1]`) }}</li>
        <li>{{ $t(`dharma-application-form.message.application-notice.content[0][2]`) }}</li>
      </ol>
    </div>
    <div v-else-if="section === 2">
      <ol style="list-style-type: disc;">
        <li>{{ $t(`dharma-application-form.message.application-notice.content[1][0]`) }}</li>
        <li>{{ $t(`dharma-application-form.message.application-notice.content[1][1]`) }}</li>
        <li>{{ $t(`dharma-application-form.message.application-notice.content[1][2]`) }}</li>
      </ol>
    </div>
    <template #modal-footer="{ close }">
      <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.ok.label') }}</b-button>
    </template>
  </b-modal>
</template>
<script>
import Vue from 'vue'

import { ButtonPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(ButtonPlugin)
Vue.use(ModalPlugin)

export default {
  i18n,
  name: 'application-notice-message-modal',
  props: {
    id: { type: String, required: true },
    section: { type: Number, required: true }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  }
}
</script>
